import { ProductExperienceService } from '$lib/services/product-experience';
import { AOFL_PRODUCT_NAMES } from '$lib/utils/constants';

/**
 *  @type {{[key: string]: import('$lib/utils/page').PageCondition}} conditions - The conditions object containing the conditions to be resolved.
 */
const pageConditions = {
	default: {
		condition: async () => true,
		resolve: async () => {
			// Purchase gift page is always only available as a 1.0 experience.
			// The request to purchase needs to use the 1.0 product uuid.
			await ProductExperienceService.setProductExperience(AOFL_PRODUCT_NAMES.ABCMOUSE);
			return await import('../_browser/Page.svelte');
		}
	}
};

export { pageConditions };
